import { Global, css } from '@emotion/core';
import { ITheme } from '../../themer';

interface IProps {
	theme: ITheme;
}

export function Separator({ theme }: IProps) {
	const styles = css`
		hr {
			background: ${theme.separator.color};
			height: ${theme.separator.height};
			border: none;
		}
	`;

	return <Global styles={styles} />;
}
